import PropTypes from 'prop-types'
import React, {Fragment, useEffect, useState} from 'react'
import perMeterCalc from '../../utils/perMeterCalc'
import calc from './calc'
import { Resizable, ResizableInside, ArrowTopRight, ArrowBottomRight, ArrowTopLeft } from './theme'

const ResizableProduct = ({
  perMeter,
  onResize,
  minSize,
  maxSize,
  width,
  height,
  index,
  isResizing,
  allowToResize,
  aspect = 1
}) => {
    const [dim, setDim] = useState()


    useEffect(() => {
        setDim([width,height])
    }, [])


  const aspectMaxSize = maxSize.map(w => w/aspect)
  const aspectMinSize = minSize.map(w => w/aspect)


  return (
    <Resizable
      width={calc(0, width, aspectMinSize, aspectMaxSize, perMeter)}
      height={calc(1, height, aspectMinSize, aspectMaxSize, perMeter)}
      onResize={(e, data, ref, delta) => {
        onResize(index, {deltaX: (dim[0] + delta.width)*aspect, deltaY: (dim[1] + delta.height)*aspect}, false, data)
      }}
      onResizeStop={(e, data, ref, delta) => onResize(index, {deltaX: (dim[0] + delta.width)*aspect, deltaY: (dim[1] + delta.height)*aspect}, true, data)}

      minWidth={aspectMinSize.map(w => perMeterCalc(w, perMeter))[0]}
      minHeight={aspectMinSize.map(w => perMeterCalc(w, perMeter))[1]}
      maxWidth={aspectMaxSize.map(w => perMeterCalc(w, perMeter))[0]}
      maxHeight={aspectMaxSize.map(w => perMeterCalc(w, perMeter))[1]}
     >

      {allowToResize && (
          <Fragment>
            {/*<ArrowTopLeft className={'react-resizable-handle'} />*/}
            {/*<ArrowTopRight className={'react-resizable-handle'} />*/}
            <ArrowBottomRight className={'react-resizable-handle'} />
          </Fragment>
      )}

      <ResizableInside
        w={calc(0, width, aspectMinSize, aspectMaxSize, perMeter)}
        h={calc(1, height, aspectMinSize, aspectMaxSize, perMeter)}
        isResizing={false !== isResizing && index === isResizing}
      />

    </Resizable>
  )
}

ResizableProduct.propTypes = {
  perMeter: PropTypes.number.isRequired,
  onResize: PropTypes.func.isRequired,
  minSize: PropTypes.arrayOf(PropTypes.number).isRequired,
  maxSize: PropTypes.arrayOf(PropTypes.number).isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  isResizing: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  allowToResize: PropTypes.bool.isRequired,
}

export default ResizableProduct



// WEBPACK FOOTER //
// ./src/components/ResizableProduct/index.js